namespace advisorop.components.meetinghub {
    export class MeetingDocumentsNotesController {
        meeting: domains.IMeeting;
        participant: domains.IMeetingParticipant;
        authorized: boolean = false;
        documents: domains.IDmsDocument[];

        _meetingHubService: services.MeetingHubService;

        constructor(private meetingHubService: services.MeetingHubService) {
            this._meetingHubService = meetingHubService;
        }

        getDocuments(): void {
            this.documents = []
            this._meetingHubService.getDocuments(this.meeting.guid, this.participant.guid)
                .then(result => {
                    this.documents = result.data.concat();
                    this.authorized = true;
                }, err => {
                    this.authorized = false;
                    console.log("getDocuments failed");
                })
        }

        loginResult(result: any): void {
            if (result > 0) {
                this.getDocuments();
            }
        }
        logout(): void {
            localStorage.clear();
            this._meetingHubService.logout().then(result => {
                this.authorized = false;
            });

        }

        $onInit(): void {
        }

        $onChanges(evt): void {
            if (this.meeting != undefined && this.participant != undefined) {
                this.getDocuments();
            }
        }

    }

    class MeetingDocumentsNotes implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                meeting: "<",
                participant: "<"
            };
            this.controller = [`meetingHubService`, MeetingDocumentsNotesController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/meeting-hub-module/components/meeting-documents-notes.html`;
        }
    }
    angular.module(Constants.APP).component(`meetingDocumentsNotes`, new MeetingDocumentsNotes());
}